module.exports = __webpack_public_path__ + "static/img/C-Block.ed9af3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/C-Block.jpg
// module id = Kpqa
// module chunks = 1